import { useContext, useEffect, useReducer, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Badge } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { isArray } from 'lodash'
import {
  BellRing,
  BookUser,
  Bot,
  Calendar,
  ChartLine,
  CheckSquare,
  ClipboardList,
  FileText,
  LayoutDashboard,
  Megaphone,
  MessageCircle,
  MessageSquareQuote,
  Music,
  ReceiptText,
  Send,
  Settings2,
  Signal,
  Sparkles,
  SquareUserRound,
  Tag,
  UserRoundPlus,
  UsersRound
} from 'lucide-react'
import { ListItemLink } from '../components/ListItemLink'
import { AuthContext } from '../context/Auth/AuthContext'
import { SocketContext } from '../context/Socket/SocketContext'
import { WhatsAppsContext } from '../context/WhatsApp/WhatsAppsContext'
import toastError from '../errors/toastError'
import api from '../services/api'
import { i18n } from '../translate/i18n'

import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import useAuth from '../hooks/useAuth.js'
import useSettings from '../hooks/useSettings'
import {
  defaultExperimentalMenuItemKeys
} from './experimentalMenuItems'
import { useStyles } from './style'

// const gitinfo = loadJSON('/gitinfo.json')

const reducer = (state, action) => {
  if (action.type === 'LOAD_CHATS') {
    const chats = action.payload
    const newChats = []

    if (isArray(chats)) {
      chats.forEach(chat => {
        const chatIndex = state.findIndex(u => u.id === chat.id)
        if (chatIndex !== -1) {
          state[chatIndex] = chat
        } else {
          newChats.push(chat)
        }
      })
    }

    return [...state, ...newChats]
  }

  if (action.type === 'UPDATE_CHATS') {
    const chat = action.payload
    const chatIndex = state.findIndex(u => u.id === chat.id)

    if (chatIndex !== -1) {
      state[chatIndex] = chat
      return [...state]
    } else {
      return [chat, ...state]
    }
  }

  if (action.type === 'DELETE_CHAT') {
    const chatId = action.payload

    const chatIndex = state.findIndex(u => u.id === chatId)
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1)
    }
    return [...state]
  }

  if (action.type === 'RESET') {
    return []
  }

  if (action.type === 'CHANGE_CHAT') {
    const changedChats = state.map(chat => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat
      }
      return chat
    })
    return changedChats
  }
}

const MainListItems = props => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { drawerClose } = props
  const { user } = useContext(AuthContext) // Obtemos o usuário do AuthContext
  const { whatsApps } = useContext(WhatsAppsContext)
  const [connectionWarning, setConnectionWarning] = useState(false)
  // const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false)
  // const [openKanbanSubmenu, setOpenKanbanSubmenu] = useState(false)

  const [showCampaigns, setShowCampaigns] = useState(false)
  const [enableExperimental, setEnableExperimental] = useState(false)
  const [experimentalMenuItems, setExperimentalMenuItems] = useState(
    defaultExperimentalMenuItemKeys
  )
  const history = useHistory()
  const [, setInvisible] = useState(true)
  const [pageNumber, setPageNumber] = useState(1)
  const [searchParam] = useState('')
  const [chats, dispatch] = useReducer(reducer, [])
  // const [version, setVersion] = useState('v N/A')

  const { getCurrentUserInfo } = useAuth()
  const { getPublicSetting } = useSettings()

  useEffect(() => {
    let mounted = true

    const loadExperimentalSetting = async () => {
      try {
        const [value, menuItemsValue] = await Promise.all([
          getPublicSetting('enableExperimental'),
          getPublicSetting('experimentalMenuItems')
        ])
        if (mounted) {
          setEnableExperimental(value === 'enabled' || value === 'true')
          if (menuItemsValue) {
            try {
              const parsedItems = JSON.parse(menuItemsValue)
              if (Array.isArray(parsedItems)) {
                setExperimentalMenuItems(parsedItems)
              }
            } catch {
              setExperimentalMenuItems(defaultExperimentalMenuItemKeys)
            }
          }
        }
      } catch {
        if (mounted) {
          setEnableExperimental(false)
        }
      }
    }

    loadExperimentalSetting()

    return () => {
      mounted = false
    }
  }, [getPublicSetting])
  const [currentUser, setCurrentUser] = useState({})

  const location = useLocation()
  const [selectedItemMenuList, setSelectedItemMenuList] = useState(() => {
    return location.pathname === '/'
      ? 1
      : location.pathname === '/tickets'
        ? 2
        : location.pathname === '/chats'
          ? 3
          : location.pathname === '/quick-messages'
            ? 4
            : location.pathname === '/schedules'
              ? 5
              : location.pathname === '/contacts'
                ? 6
                : location.pathname === '/contact-files'
                  ? 61
                  : location.pathname === '/clientes'
                    ? 82
                    : location.pathname === '/tags'
                      ? 7
                      : location.pathname === '/tasks'
                        ? 8
                        : location.pathname === '/reminders'
                          ? 81
                          : location.pathname === '/notification-sounds'
                            ? 83
                            : location.pathname === '/campaigns'
                              ? 9
                              : location.pathname === '/contact-lists'
                                ? 10
                                : location.pathname === '/announcements'
                                  ? 11
                                  : location.pathname === '/connections'
                                    ? 12
                                    : location.pathname === '/queues'
                                      ? 13
                                      : location.pathname === '/'
                                        ? 14
                                        : location.pathname === '/users'
                                          ? 15
                                          : location.pathname === '/Relatorios'
                                            ? 15
                                            : location.pathname === '/settings'
                                              ? 16
                                              : location.pathname ===
                                                '/messages-api'
                                                ? 17
                                                : location.pathname ===
                                                  '/wizard'
                                                  ? 18
                                                  : location.pathname ===
                                                    '/departments'
                                                    ? 19
                                                    : location.pathname ===
                                                      '/painel-gestor'
                                                      ? 20
                                                      : location.pathname ===
                                                        '/closing-reasons'
                                                        ? 21
                                                        : null
  })

  const socketManager = useContext(SocketContext)

  useEffect(() => {
    const socket = socketManager.GetSocket()

    const getCurrentMenuItem = pathname => {
      const menuItemPaths = [
        ['dashboard', '/'],
        ['tickets', '/tickets'],
        ['quickMessages', '/quick-messages'],
        ['schedules', '/schedules'],
        ['tags', '/tags'],
        ['tasks', '/tasks'],
        ['reminders', '/reminders'],
        ['notificationSounds', '/notification-sounds'],
        ['contacts', '/contacts'],
        ['clients', '/clientes'],
        ['contactFiles', '/contact-files'],
        ['campaigns', '/campaigns'],
        ['contactLists', '/contact-lists'],
        ['financeiro', '/financeiro'],
        ['announcements', '/announcements'],
        ['users', '/users'],
        ['reports', '/Relatorios'],
        ['managerPanel', '/painel-gestor'],
        ['connections', '/connections'],
        ['departments', '/departments'],
        ['wizard', '/Wizard']
      ]

      return menuItemPaths.find(([, path]) =>
        path === '/' ? pathname === path : pathname.startsWith(path)
      )?.[0]
    }

    const redirectIfCurrentPageIsHidden = (enabled, menuItems) => {
      const currentMenuItem = getCurrentMenuItem(location.pathname)
      if (!enabled && currentMenuItem && menuItems.includes(currentMenuItem)) {
        history.replace('/tickets')
      }
    }

    const onExperimentalSettings = data => {
      if (data?.key === 'enableExperimental') {
        const enabled = data.value === 'enabled' || data.value === 'true'
        setEnableExperimental(enabled)
        redirectIfCurrentPageIsHidden(enabled, experimentalMenuItems)
        return
      }

      if (data?.key === 'experimentalMenuItems') {
        try {
          const menuItems = JSON.parse(data.value)
          if (Array.isArray(menuItems)) {
            setExperimentalMenuItems(menuItems)
            redirectIfCurrentPageIsHidden(enableExperimental, menuItems)
          }
        } catch {
          setExperimentalMenuItems(defaultExperimentalMenuItemKeys)
          redirectIfCurrentPageIsHidden(
            enableExperimental,
            defaultExperimentalMenuItemKeys
          )
        }
      }
    }

    socket.on('experimentalSettings', onExperimentalSettings)

    return () => {
      socket.off('experimentalSettings', onExperimentalSettings)
    }
  }, [enableExperimental, experimentalMenuItems, history, location.pathname, socketManager])

  useEffect(() => {
    const userId = Number(localStorage.getItem('userId'))
    if (currentUser?.id === userId) {
      return
    }
    getCurrentUserInfo().then(u => {
      // console.log('CurrentUser data:', u) // Debug log
      setCurrentUser(u)
    })
  }, [getCurrentUserInfo])

  useEffect(() => {
    dispatch({ type: 'RESET' })
    setPageNumber(1)
  }, [searchParam])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats()
    }, 500)
    return () => clearTimeout(delayDebounceFn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber])

  useEffect(() => {
    const companyId = localStorage.getItem('companyId')
    const socket = socketManager.GetSocket(companyId)

    const onCompanyChatMainListItems = data => {
      if (data.action === 'new-message') {
        dispatch({ type: 'CHANGE_CHAT', payload: data })
      }
      if (data.action === 'update') {
        dispatch({ type: 'CHANGE_CHAT', payload: data })
      }
    }

    socket.on(`company-${companyId}-chat`, onCompanyChatMainListItems)
    return () => {
      socket.disconnect()
    }
  }, [socketManager])

  useEffect(() => {
    let unreadsCount = 0
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false)
    } else {
      setInvisible(true)
    }
  }, [chats, user.id])

  useEffect(() => {
    if (localStorage.getItem('cshow')) {
      setShowCampaigns(true)
    }
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter(whats => {
          return (
            whats.status === 'qrcode' ||
            whats.status === 'PAIRING' ||
            whats.status === 'DISCONNECTED' ||
            whats.status === 'TIMEOUT' ||
            whats.status === 'OPENING'
          )
        })
        setConnectionWarning(offlineWhats.length > 0)
      }
    }, 2000)
    return () => clearTimeout(delayDebounceFn)
  }, [whatsApps, history])

  const fetchChats = async () => {
    try {
      const { data } = await api.get('/chats/', {
        params: { searchParam, pageNumber }
      })
      dispatch({ type: 'LOAD_CHATS', payload: data.records })
    } catch (err) {
      toastError(err)
    }
  }

  const [userRoles, setUserRoles] = useState([]) // Estado para armazenar as roles do usuário

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const response = await api.get(`/role/${user?.id}`) // Endpoint para buscar roles do usuário
        setUserRoles(response.data) // Atualiza o estado com as roles
      } catch (error) {
        console.error('Erro ao buscar roles do usuário:', error)
      }
    }

    if (user?.id) {
      fetchUserRoles()
    }
  }, [user])

  // Função auxiliar para verificar se o usuário tem uma role específica
  const hasRole = (userObj, roleName) => {
    if (!userObj) return false

    // Verifica se tem a propriedade roles (array) carregada do contexto
    if (userObj.roles && Array.isArray(userObj.roles)) {
      return userObj.roles.some(r => r.role === roleName)
    }

    // Verifica se tem roles carregadas via API
    if (userRoles && Array.isArray(userRoles)) {
      return userRoles.some(r => r.role === roleName)
    }

    // Verifica se tem a propriedade profile (string)
    if (userObj.profile) {
      return userObj.profile === roleName
    }

    return false
  }

  // Função para verificar se é admin ou super
  const isAdminOrSuper = userObj => {
    return (
      hasRole(userObj, 'admin') ||
      hasRole(userObj, 'super') ||
      userObj?.super === true
    )
  }

  // Função para verificar se tem acesso a conexões
  const hasConnectionsAccess = userObj => {
    return isAdminOrSuper(userObj) || hasRole(userObj, 'conexões')
  }

  // Função para verificar se tem acesso a relatórios
  const hasReportsAccess = userObj => {
    return isAdminOrSuper(userObj) || hasRole(userObj, 'relatorios')
  }

  // Função para verificar se tem acesso a departamentos (queues)
  const hasDepartmentsAccess = userObj => {
    return isAdminOrSuper(userObj) || hasRole(userObj, 'departamentos')
  }

  // Função para verificar se tem acesso à página de usuários
  const hasUsersAccess = userObj => {
    return (
      hasRole(userObj, 'admin') ||
      hasRole(userObj, 'super') ||
      hasRole(userObj, 'usuarios')
    )
  }

  // Função para verificar se tem acesso ao painel gestor
  const hasGestorAccess = userObj => {
    return isAdminOrSuper(userObj) || hasRole(userObj, 'gestor')
  }

  const isSuper = userObj => {
    return hasRole(userObj, 'super') || userObj?.super === true
  }

  const isExperimentalMenuItemVisible = itemKey => {
    return enableExperimental || !experimentalMenuItems.includes(itemKey)
  }

  return (
    <div onClick={drawerClose} className={classes.menuList}>
      {/* Dashboard - Primeiro item, separado */}
      {!isMobile &&
        isAdminOrSuper(currentUser) &&
        isExperimentalMenuItemVisible('dashboard') && (
          <>
            <Divider />
            <ListItemLink
              small
              to="/"
              primary="Dashboard"
              icon={<LayoutDashboard className={classes.listItemLinkIcon} />}
              id={1}
              isSelected={selectedItemMenuList === 1}
              onSelect={setSelectedItemMenuList}
            />
            <Divider />
          </>
        )}

      {/* GRUPO 1: Atendimentos - Páginas básicas disponíveis para todos os usuários autenticados */}
      {(currentUser?.id || user?.id) && (
        <>
          {isExperimentalMenuItemVisible('tickets') && <ListItemLink
            to="/tickets"
            primary={i18n.t('mainDrawer.listItems.tickets')}
            icon={<MessageCircle className={classes.listItemLinkIcon} />}
            id={2}
            isSelected={selectedItemMenuList === 2}
            onSelect={setSelectedItemMenuList}
          />}

          {isExperimentalMenuItemVisible('quickMessages') && <ListItemLink
            to="/quick-messages"
            primary={i18n.t('mainDrawer.listItems.quickMessages')}
            icon={<MessageSquareQuote className={classes.listItemLinkIcon} />}
            id={4}
            isSelected={selectedItemMenuList === 4}
            onSelect={setSelectedItemMenuList}
          />}
          {isExperimentalMenuItemVisible('schedules') && <ListItemLink
            to="/schedules"
            primary={i18n.t('mainDrawer.listItems.schedules')}
            icon={<Calendar className={classes.listItemLinkIcon} />}
            id={5}
            isSelected={selectedItemMenuList === 5}
            onSelect={setSelectedItemMenuList}
          />}
          {!isMobile && isExperimentalMenuItemVisible('tags') && (
            <ListItemLink
              to="/tags"
              primary={i18n.t('mainDrawer.listItems.tags')}
              icon={<Tag className={classes.listItemLinkIcon} />}
              id={7}
              isSelected={selectedItemMenuList === 7}
              onSelect={setSelectedItemMenuList}
            />
          )}
          {(isExperimentalMenuItemVisible('tasks') ||
            isExperimentalMenuItemVisible('reminders')) && (
              <>
                {isExperimentalMenuItemVisible('tasks') && <ListItemLink
                  to="/tasks"
                  primary={'Tarefas'}
                  icon={<CheckSquare className={classes.listItemLinkIcon} />}
                  id={8}
                  isSelected={selectedItemMenuList === 8}
                  onSelect={setSelectedItemMenuList}
                />}

                {isExperimentalMenuItemVisible('reminders') && <ListItemLink
                  to="/reminders"
                  primary={'Lembretes'}
                  icon={<BellRing className={classes.listItemLinkIcon} />}
                  id={81}
                  isSelected={selectedItemMenuList === 81}
                  onSelect={setSelectedItemMenuList}
                />}
              </>
            )}
          {/*  {isExperimentalMenuItemVisible('notificationSounds') && (
            <>
              {isSuper(currentUser) && (
                <ListItemLink
                  to="/notification-sounds"
                  primary={'Sons de Notificação'}
                  icon={<Music className={classes.listItemLinkIcon} />}
                  id={83}
                  isSelected={selectedItemMenuList === 83}
                  onSelect={setSelectedItemMenuList}
                />
              )}
            </>
          )} */}
          {isExperimentalMenuItemVisible('contacts') && <ListItemLink
            to="/contacts"
            primary={i18n.t('mainDrawer.listItems.contacts')}
            icon={<SquareUserRound className={classes.listItemLinkIcon} />}
            id={9}
            isSelected={selectedItemMenuList === 9}
            onSelect={setSelectedItemMenuList}
          />}
          {(isExperimentalMenuItemVisible('clients') ||
            isExperimentalMenuItemVisible('contactFiles')) && (
              <>
                {isExperimentalMenuItemVisible('clients') && <ListItemLink
                  to="/clientes"
                  primary={'Clientes'}
                  icon={<UserRoundPlus className={classes.listItemLinkIcon} />}
                  id={82}
                  isSelected={selectedItemMenuList === 82}
                  onSelect={setSelectedItemMenuList}
                />}
                {isExperimentalMenuItemVisible('contactFiles') && <ListItemLink
                  to="/contact-files"
                  primary={i18n.t('mainDrawer.listItems.contactFiles')}
                  icon={<FileText className={classes.listItemLinkIcon} />}
                  id={61}
                  isSelected={selectedItemMenuList === 61}
                  onSelect={setSelectedItemMenuList}
                />}
              </>
            )}
          <Divider />
        </>
      )}

      {/* GRUPO 2: Menu Avançado/Administrativo - campanhas, anúncios, financeiro, usuários, bot, conexões e relatórios */}
      {!isMobile &&
        (isAdminOrSuper(currentUser) ||
          hasUsersAccess(currentUser) ||
          hasReportsAccess(currentUser) ||
          hasConnectionsAccess(currentUser) ||
          hasDepartmentsAccess(currentUser) ||
          hasGestorAccess(currentUser)) && (
          <>
            {/* Campanhas - apenas para admin e super */}
            {isAdminOrSuper(currentUser) &&
              showCampaigns &&
              (isExperimentalMenuItemVisible('campaigns') ||
                isExperimentalMenuItemVisible('contactLists')) && (
                <>
                  {isExperimentalMenuItemVisible('campaigns') && <ListItemLink
                    to="/campaigns"
                    primary={i18n.t('mainDrawer.listItems.campaigns')}
                    icon={<Send className={classes.listItemLinkIcon} />}
                    id={8}
                    isSelected={selectedItemMenuList === 8}
                    onSelect={setSelectedItemMenuList}
                  />}
                  {isExperimentalMenuItemVisible('contactLists') && <ListItemLink
                    to="/contact-lists"
                    primary={'Lista de Contatos'}
                    icon={<BookUser className={classes.listItemLinkIcon} />}
                    id={9}
                    isSelected={selectedItemMenuList === 9}
                    onSelect={setSelectedItemMenuList}
                  />}
                </>
              )}

            {/* Financeiro - disponível para admin e super */}
            {isExperimentalMenuItemVisible('financeiro') && (
              <>
                {isAdminOrSuper(currentUser) && (
                  <ListItemLink
                    to="/financeiro"
                    primary={i18n.t('mainDrawer.listItems.financeiro')}
                    icon={<ReceiptText className={classes.listItemLinkIcon} />}
                    id={14}
                    isSelected={selectedItemMenuList === 14}
                    onSelect={setSelectedItemMenuList}
                  />
                )}
              </>
            )}

            {/* Anúncios - apenas para super */}
            {isExperimentalMenuItemVisible('announcements') && (
              <>
                {isSuper(currentUser) && (
                  <ListItemLink
                    to="/announcements"
                    primary={i18n.t('mainDrawer.listItems.annoucements')}
                    icon={<Megaphone />}
                    id={10}
                    isSelected={selectedItemMenuList === 10}
                    onSelect={setSelectedItemMenuList}
                  />
                )}
              </>
            )}

            {/* Página Users - disponível para admin, super e usuarios */}
            {hasUsersAccess(currentUser) &&
              isExperimentalMenuItemVisible('users') && (
                <ListItemLink
                  to="/users"
                  primary={i18n.t('mainDrawer.listItems.users')}
                  icon={<UsersRound className={classes.listItemLinkIcon} />}
                  id={13}
                  isSelected={selectedItemMenuList === 13}
                  onSelect={setSelectedItemMenuList}
                />
              )}

            {/* Página Relatórios - disponível para admins, super e usuarios com role "relatorios" */}
            {isExperimentalMenuItemVisible('reports') &&
              hasReportsAccess(currentUser) && (
                <ListItemLink
                  to="/Relatorios"
                  primary="Relatorios"
                  icon={<ChartLine className={classes.listItemLinkIcon} />}
                  id={15}
                  isSelected={selectedItemMenuList === 15}
                  onSelect={setSelectedItemMenuList}
                />
              )}

            {/* Painel Gestor - disponível para admin, super e usuários com role "gestor" */}
            {isExperimentalMenuItemVisible('managerPanel') &&
              hasGestorAccess(currentUser) && (
                <ListItemLink
                  to="/painel-gestor"
                  primary="Painel Gestor"
                  icon={<ClipboardList className={classes.listItemLinkIcon} />}
                  id={20}
                  isSelected={selectedItemMenuList === 20}
                  onSelect={setSelectedItemMenuList}
                />
              )}

            {/* Página Conexões - disponível para admins, super e usuarios com role "conexões" */}
            {hasConnectionsAccess(currentUser) &&
              isExperimentalMenuItemVisible('connections') && (
                <ListItemLink
                  to="/connections"
                  primary={i18n.t('mainDrawer.listItems.connections')}
                  icon={
                    <Badge
                      badgeContent={connectionWarning ? '!' : 0}
                      color="error"
                      overlap="rectangular"
                    >
                      <Signal className={classes.listItemLinkIcon} />
                    </Badge>
                  }
                  id={11}
                  isSelected={selectedItemMenuList === 11}
                  onSelect={setSelectedItemMenuList}
                />
              )}

            {/* Página Departamentos/Bot - disponível para admins, super e usuarios com role "departamentos" */}
            {hasDepartmentsAccess(currentUser) &&
              isExperimentalMenuItemVisible('departments') && (
                <>
                  <ListItemLink
                    to="/departments"
                    primary="Departamentos"
                    icon={<Bot className={classes.listItemLinkIcon} />}
                    id={19}
                    isSelected={selectedItemMenuList === 19}
                    onSelect={setSelectedItemMenuList}
                  />

                  {/* Removido a pagina de Bot */}
                  {/* <ListItemLink
                to="/queues"
                primary={i18n.t('mainDrawer.listItems.queues')}
                icon={<Bot className={classes.listItemLinkIcon} />}
                id={12}
                isSelected={selectedItemMenuList === 12}
                onSelect={setSelectedItemMenuList}
              /> */}
                </>
              )}
            <Divider />
          </>
        )}

      {/* GRUPO 3: Configurações - Settings, API e Wizard */}
      {!isMobile &&
        (isAdminOrSuper(currentUser) || hasRole(currentUser, 'auditoria')) &&
        isExperimentalMenuItemVisible('settings') && (
          <ListItemLink
            to="/settings"
            primary={i18n.t('mainDrawer.listItems.settings')}
            icon={<Settings2 className={classes.listItemLinkIcon} />}
            id={16}
            isSelected={selectedItemMenuList === 16}
            onSelect={setSelectedItemMenuList}
          />
        )}
      {!isMobile &&
        isAdminOrSuper(currentUser) &&
        isExperimentalMenuItemVisible('wizard') && (
          <>
            {/* <ListItemLink
            to="/messages-api"
            primary={i18n.t('mainDrawer.listItems.messagesAPI')}
            icon={<CodeRoundedIcon className={classes.listItemLinkIcon} />}
            id={17}
            isSelected={selectedItemMenuList === 17}
            onSelect={setSelectedItemMenuList}
          /> */}
            <ListItemLink
              to="/wizard"
              primary="Wizard"
              icon={<Sparkles className={classes.listItemLinkIcon} />}
              id={18}
              isSelected={selectedItemMenuList === 18}
              onSelect={setSelectedItemMenuList}
            />
            {/** 
          <ListItemLink
            to="/closing-reasons"
            primary="Motivos de Finalização"
            icon={<CheckSquare className={classes.listItemLinkIcon} />}
            id={21}
            isSelected={selectedItemMenuList === 21}
            onSelect={setSelectedItemMenuList}
          />
          */}
          </>
        )}
    </div>
  )
}

export default MainListItems
